import reducer from "./reducer";
export { default as FavouriteButton } from "./components/index";
export { default as favouriteButtonReducerName } from "./constants";
export default reducer;
